<template>
  <div class="home">
    <div class="blue-circle top"></div>
    <div class="body">
      <div class="logo">
        <div class="logo-wrap">
          <div class="logo-wrap-left" @click="$router.push('/change')">
            <img
              v-if="userBaseInfo.avatar"
              class="img"
              :src="userBaseInfo.avatar"
            />
            <van-button plain type="info">
              {{ userBaseInfo.nickname }} - {{ userBaseInfo.mobile }}
              <van-icon name="edit" />
            </van-button>
          </div>
          <div class="logo-wrap-right">
            <van-button @click="logout" plain type="danger">退出</van-button>
          </div>
        </div>
        <div class="t1">客户管理平台</div>
        <div class="t2">CRM Customer Management Platform</div>
      </div>
      <div class="content">
        <div
          class="item"
          @click="routerPush({ name: 'ListCase', query: { orderStatus: '0' } })"
        >
          <div class="left">
            <div class="title">线索</div>
            <div class="condition">我的线索</div>
          </div>
          <div class="right">
            <span>{{ indexCount.clueCount }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div
          class="item"
          @click="
            routerPush({ name: 'List', query: { statusEq: 'PROCESSING' } })
          "
        >
          <div class="left">
            <div class="title">客户</div>
            <div class="condition">
              <span>我的客户</span>
              <a
                class="map-link"
                @click.stop="routerPush({ name: 'Calendar' })"
                href="javascript:void(0)"
                >跟进日历</a
              >
            </div>
          </div>
          <div class="right">
            <span>{{ indexCount.customerCount }}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { Tabbar, TabbarItem, Toast, Dialog } from "vant";
import { clearUserInfo } from "@/libs/utils";
import watermark from "@/libs/watermark";
Vue.use(Tabbar);
Vue.use(TabbarItem);

import Api from "@/api/caseHandle";
import ApiUser from "@/api/user";

export default {
  name: "Home",
  data() {
    return {
      indexCount: {
        clueCount: "",
        customerCount: "",
      },
    };
  },
  created() {},
  methods: {
    ...mapActions(["getSimpleList"]),
    routerPush() {
      this.$router.push(...arguments);
    },

    async getOrgIndexCount() {
      try {
        const res = await Api.getOrgIndexCount();
        Object.assign(this.indexCount, res.data);
      } catch (error) {
        Toast.fail(error);
      }
    },

    imgError(e) {
      e.target.src = require("@/assets/images/logo@2x.png");
    },

    logout() {
      Dialog.confirm({
        title: "提示",
        message: "确定要退出登录吗？",
        theme: "round-button",
      })
        .then(async () => {
          await ApiUser.logout();
          clearUserInfo();
          window.location.href = "/login";
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  async mounted() {
    this.getSimpleList();
    watermark(document.getElementById("app"));
  },
  activated() {
    this.getOrgIndexCount();
  }
};
</script>
<style lang="less" scoped>
.blue-circle {
  width: 118px;
  height: 10px;
  background: #3c86ff;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  &.top {
    border-radius: 0px 0px 100px 100px;
    top: 0px;
  }
}
.home {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  .body {
    flex: 1;
    display: flex;
    flex-direction: column;

    .logo {
      padding: 40px 32px;
      .img {
        width: 49px;
        display: block;
      }
      .t1 {
        margin-top: 20px;
        font-weight: Medium;
        font-size: 20px;
        color: #212528;
        letter-spacing: 0;
      }
      .t2 {
        margin-top: 3px;
        font-weight: Medium;
        font-size: 9px;
        color: #9a9ea1;
        letter-spacing: 0;
      }
      button {
        border: none;
        background: none;
      }
      .logo-wrap {
        display: flex;
        justify-content: space-between;
        .logo-wrap-left {
          display: flex;
          align-items: center;
        }
        .logo-wrap-right {
          .van-button {
            margin-left: 10px;
          }
        }
      }
    }

    .line {
      height: 1px;
      opacity: 0.11;
      &.l1 {
        background: #787b84;
      }
      &.l2 {
        background: #ffffff;
      }
    }

    .content {
      flex: 1;
      overflow-y: auto;
      padding: 10px 12px;
      padding-bottom: 50px;

      .item {
        margin-top: 15px;
        background: #ffffff;
        border-radius: 6px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 22px 20px 22px 24px;
        .left {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            font-weight: Medium;
            font-size: 16px;
            color: #393939;
            letter-spacing: 0;
          }
          .condition {
            margin-top: 8px;
            font-weight: Regular;
            font-size: 12px;
            color: #a0a5b5;
            letter-spacing: 0;

            &.warning {
              color: #da9456;
            }
            &.danger {
              color: #ff6363;
            }
            .map-link {
              margin-left: 10px;
              text-decoration: underline;
            }
          }
        }

        .right {
          display: flex;
          align-items: center;
          span {
            font-weight: Medium;
            font-size: 24px;
            color: #000000;
            letter-spacing: 0;
            text-align: right;
          }
          .van-icon {
            margin-left: 10px;
            font-size: 20px;
            font-weight: bold;
            color: #d3d6dc;
          }
        }

        &::before {
          position: absolute;
          content: " ";
          top: 0px;
          left: 18px;
          width: 48px;
          height: 4px;
          background: #3c86ff;
          border-radius: 0 0 100px 100px;
        }
      }
    }
  }
  .footer {
    height: 50px;
  }
}
</style>
